import { createAsyncThunk } from '@reduxjs/toolkit'
import DataService from "../service";
import { constant } from '../constant'
const { path } = constant;

export const fetchReportList = createAsyncThunk(
    'report/fetchReport',
    (arg, { rejectWithValue }) => DataService.get(arg,  path+'client/report/v1/current-report', rejectWithValue)
)

export const downloadCsvCurrentReport = createAsyncThunk(
    'report/downloadCsvCurrentReport',
    (arg, { rejectWithValue }) => DataService.get(arg,  path+'client/report/v1/current-report-csv', rejectWithValue)
)

// export const downLoadReportDatewise = createAsyncThunk(
//     'report/downloadReportDatewise',
//     (arg, { rejectWithValue }) => DataService.get(arg,  path+`client/report/v1/datewise-report/${arg?.dateData}?hour=${arg?.hour}&minute=${arg?.minute}`, rejectWithValue)
// )

export const downLoadReportDatewise = createAsyncThunk(
  'report/downloadReportDatewise',
  async (arg, { rejectWithValue }) => {
    console.log("arg in action", arg);
    try {
      const { dateData, hour, minute } = arg;
      let endpoint = `${path}client/report/v1/datewise-report/${dateData}`;
      
      // Add params only if both hour and minute exist
      if (hour != null && minute != null) {
        endpoint += `?hour=${hour}&minute=${minute}`;
      }

      return await DataService.get({}, endpoint, rejectWithValue);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const downloadCsvDatewiseReport = createAsyncThunk(
  'report/downloadCsvDatewiseReport',
  async (arg, { rejectWithValue }) => {
    console.log("arg in action", arg);
    try {
      const { dateData, hour, minute } = arg;
      let endpoint = `${path}client/report/v1/datewise-report-csv/${dateData}`;
      
      // Add params only if both hour and minute exist
      if (hour != null && minute != null) {
        endpoint += `?hour=${hour}&minute=${minute}`;
      }

      return await DataService.get({}, endpoint, rejectWithValue);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


export const downLoadCombineReportDatewise = createAsyncThunk(
    'report/downLoadCombineReportDatewise',
    (arg, { rejectWithValue }) => DataService.get(arg,  path+`client/report/v1/vw-ucrt-datewise-report/${arg?.dateData}`, rejectWithValue)
)

